// track, thumb and active are derived from macOS 10.15.7
